enum SCROLL_DIRECTION {
  LEFT = 'left',
  RIGHT = 'right',
}

export {
  SCROLL_DIRECTION,
}
